import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../../../services/auth.service';
import { DataExportService, ExportDataset } from '../../../../services/data-export.service';
import { LoggerService } from '../../../../services/logger.service';

interface DatasetRow extends ExportDataset {
  selected: boolean;
}

@Component({
  selector: 'app-export-backup',
  templateUrl: './export-backup.component.html',
  styleUrls: ['./export-backup.component.css']
})
export class ExportBackupComponent implements OnInit {

  datasets: DatasetRow[] = [];
  loadingManifest = true;
  bulkExporting = false;

  constructor(
    private _dataExportService: DataExportService,
    private _authService: AuthService,
    private _snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this._dataExportService.getManifest().subscribe({
      next: (rows) => {
        this.datasets = rows.map(r => ({ ...r, selected: r.available }));
        this.loadingManifest = false;
      },
      error: (err) => {
        LoggerService.error('Failed to load export manifest', err);
        this._snackBar.open('Could not load export options', 'Close', { duration: 4000 });
        this.loadingManifest = false;
      },
    });
  }

  exportSelected(): void {
    const keys = this.datasets.filter(d => d.available && d.selected).map(d => d.key);
    if (!keys.length || this.bulkExporting) return;

    this.bulkExporting = true;
    const studioId = this._authService.selectedStudio?.id ?? null;
    this._dataExportService.downloadBundle(keys, studioId).subscribe({
      next: () => { this.bulkExporting = false; },
      error: (err) => {
        LoggerService.error('Bundle download failed', err);
        this._snackBar.open('Could not download backup', 'Close', { duration: 4000 });
        this.bulkExporting = false;
      },
    });
  }

  get anySelected(): boolean {
    return this.datasets.some(d => d.available && d.selected);
  }
}
